import {CSSProperties, useEffect, useState} from "react";
import {css} from "@panda/css";

import {ManualPopover} from "@pg-design/floating-module";
import {Input} from "@pg-design/inputs-module";

import {HOME_MATCH_PREFERENCES_SURVEY_CONTENT} from "../../../constants/preferences/home_match_preferences_survey_content";
import {parseRangeBound} from "../../../utils/parse_range_bound";

const {AREA_MAX_WARNING, AREA_MIN_WARNING, AREA_UNIT} = HOME_MATCH_PREFERENCES_SURVEY_CONTENT;

const WARNING_VISIBLE_MS = 2000;
const COLLAPSED_UNIT_STYLE: CSSProperties = {margin: 0, overflow: "hidden", width: 0};

const toAreaInputValue = (raw: string) => parseRangeBound(raw.replace(/\D/g, ""));

interface IProps {
    ariaLabel: string;
    max: number;
    min: number;
    onChange: (value: number | undefined) => void;
    placeholder: string;
    value: number | undefined;
}

/** Behaves like the budget amount: digits only, the whole box focuses the field, the unit hugs the value and a value out of range snaps back with a warning. */
export const HomeMatchPreferencesSurveyAreaInput = (props: IProps) => {
    const {ariaLabel, max, min, onChange, placeholder, value} = props;
    const [warning, setWarning] = useState({isOpen: false, message: ""});
    const isEmpty = value == null;
    const inputWidth = `${Math.max(String(value ?? placeholder).length, 1)}ch`;

    useEffect(() => {
        if (!warning.isOpen) return;

        const timeout = setTimeout(() => setWarning((current) => ({...current, isOpen: false})), WARNING_VISIBLE_MS);

        return () => clearTimeout(timeout);
    }, [warning.isOpen]);

    const handleBlur = () => {
        if (value == null) return;

        if (value < min) {
            setWarning({isOpen: true, message: `${AREA_MIN_WARNING} ${min}`});
            onChange(min);
            return;
        }

        if (value > max) {
            setWarning({isOpen: true, message: `${AREA_MAX_WARNING} ${max}`});
            onChange(max);
        }
    };

    return (
        <ManualPopover
            handleSetIsOpen={(isOpen) => setWarning((current) => ({...current, isOpen}))}
            isOpen={warning.isOpen}
            popover={warning.message}
            type="warning"
        >
            {({refs, getReferenceProps}) => (
                <div className={areaFieldStyle} ref={refs.setReference} style={{"--area-input-width": inputWidth} as CSSProperties} {...getReferenceProps()}>
                    <Input
                        aria-label={ariaLabel}
                        elementCustomClassName={areaUnitStyle}
                        elementCustomStyle={isEmpty ? COLLAPSED_UNIT_STYLE : undefined}
                        inputClassName={areaValueStyle}
                        inputMode="numeric"
                        inputWrapClassName={areaInputWrapStyle}
                        inputWrapperClassName={areaBoxStyle}
                        onBlur={handleBlur}
                        onChange={(event) => onChange(toAreaInputValue(event.target.value))}
                        placeholder={placeholder}
                        rightElement={isEmpty ? <span className={hiddenUnitStyle}>{AREA_UNIT}</span> : AREA_UNIT}
                        value={value ?? ""}
                    />
                </div>
            )}
        </ManualPopover>
    );
};

const areaFieldStyle = css({
    flex: "none",
    position: "relative"
});

const areaBoxStyle = css({
    alignItems: "center",
    border: "1px solid var(--colors-secondary)",
    height: "4.8rem",
    justifyContent: "flex-start",
    py: 0,
    width: "14.8rem"
});

const areaInputWrapStyle = css({
    flex: "0 0 auto",
    justifyContent: "flex-start",
    width: "auto"
});

const areaValueStyle = css({
    boxSizing: "content-box",
    height: "auto",
    textAlign: "left",
    width: "var(--area-input-width)",

    "&::placeholder": {
        color: "var(--colors-secondary)"
    }
});

const areaUnitStyle = css({
    ml: 0
});

const hiddenUnitStyle = css({
    cursor: "default",
    opacity: 0,
    pointerEvents: "none"
});
import {CSSProperties, useEffect, useState} from "react";
import {css} from "@panda/css";

import {ManualPopover} from "@pg-design/floating-module";
import {Input} from "@pg-design/inputs-module";

import {HOME_MATCH_PREFERENCES_SURVEY_CONTENT} from "../../../constants/preferences/home_match_preferences_survey_content";
import {parseRangeBound} from "../../../utils/parse_range_bound";

const {AREA_MAX_WARNING, AREA_MIN_WARNING, AREA_UNIT} = HOME_MATCH_PREFERENCES_SURVEY_CONTENT;

const WARNING_VISIBLE_MS = 2000;
const COLLAPSED_UNIT_STYLE: CSSProperties = {margin: 0, overflow: "hidden", width: 0};

const toAreaInputValue = (raw: string) => parseRangeBound(raw.replace(/\D/g, ""));

interface IProps {
    ariaLabel: string;
    max: number;
    min: number;
    onChange: (value: number | undefined) => void;
    placeholder: string;
    value: number | undefined;
}

/** Behaves like the budget amount: digits only, the whole box focuses the field, the unit hugs the value and a value out of range snaps back with a warning. */
export const HomeMatchPreferencesSurveyAreaInput = (props: IProps) => {
    const {ariaLabel, max, min, onChange, placeholder, value} = props;
    const [warning, setWarning] = useState({isOpen: false, message: ""});
    const isEmpty = value == null;
    const inputWidth = `${Math.max(String(value ?? placeholder).length, 1)}ch`;

    useEffect(() => {
        if (!warning.isOpen) return;

        const timeout = setTimeout(() => setWarning((current) => ({...current, isOpen: false})), WARNING_VISIBLE_MS);

        return () => clearTimeout(timeout);
    }, [warning.isOpen]);

    const handleBlur = () => {
        if (value == null) return;

        if (value < min) {
            setWarning({isOpen: true, message: `${AREA_MIN_WARNING} ${min}`});
            onChange(min);
            return;
        }

        if (value > max) {
            setWarning({isOpen: true, message: `${AREA_MAX_WARNING} ${max}`});
            onChange(max);
        }
    };

    return (
        <ManualPopover
            handleSetIsOpen={(isOpen) => setWarning((current) => ({...current, isOpen}))}
            isOpen={warning.isOpen}
            popover={warning.message}
            type="warning"
        >
            {({refs, getReferenceProps}) => (
                <div className={areaFieldStyle} ref={refs.setReference} style={{"--area-input-width": inputWidth} as CSSProperties} {...getReferenceProps()}>
                    <Input
                        aria-label={ariaLabel}
                        elementCustomClassName={areaUnitStyle}
                        elementCustomStyle={isEmpty ? COLLAPSED_UNIT_STYLE : undefined}
                        inputClassName={areaValueStyle}
                        inputMode="numeric"
                        inputWrapClassName={areaInputWrapStyle}
                        inputWrapperClassName={areaBoxStyle}
                        onBlur={handleBlur}
                        onChange={(event) => onChange(toAreaInputValue(event.target.value))}
                        placeholder={placeholder}
                        rightElement={isEmpty ? <span className={hiddenUnitStyle}>{AREA_UNIT}</span> : AREA_UNIT}
                        value={value ?? ""}
                    />
                </div>
            )}
        </ManualPopover>
    );
};

const areaFieldStyle = css({
    flex: "none",
    position: "relative"
});

const areaBoxStyle = css({
    alignItems: "center",
    border: "1px solid var(--colors-secondary)",
    height: "4.8rem",
    justifyContent: "flex-start",
    py: 0,
    width: "14.8rem"
});

const areaInputWrapStyle = css({
    flex: "0 0 auto",
    justifyContent: "flex-start",
    width: "auto"
});

const areaValueStyle = css({
    boxSizing: "content-box",
    height: "auto",
    textAlign: "left",
    width: "var(--area-input-width)",

    "&::placeholder": {
        color: "var(--colors-secondary)"
    }
});

const areaUnitStyle = css({
    ml: 0
});

const hiddenUnitStyle = css({
    cursor: "default",
    opacity: 0,
    pointerEvents: "none"
});
